import { ButtonColor, ButtonShape, CopyToClipboardButton, IconSize } from "@quortex/front-common"
import { isEmpty } from "lodash-es"
import { useMemo } from "react"

type Props = {
  contentSteering: api.ott.Pool["contentSteering"]
}

const SwitchConfiguredUrlList = ({ contentSteering }: Props) => {
  const { hlsServerAddress, dashServerAddress } = contentSteering || {}
  const switchUrlList = useMemo(() => {
    if (!contentSteering?.enabled || (isEmpty(hlsServerAddress) && isEmpty(dashServerAddress)))
      return []
    return [
      {
        label: "For DASH manifests",
        type: "dash",
        value: dashServerAddress || ""
      },
      {
        label: "For HLS playlists",
        type: "hls",
        value: hlsServerAddress || ""
      }
    ]
  }, [contentSteering, hlsServerAddress, dashServerAddress])

  return (
    <div className="mt-lg">
      <p className="mb-sm font-medium">Quortex Switch URLs</p>
      {switchUrlList.map(({ label, value, type }) => (
        <div
          key={type}
          className="radius-sm mb-sm flex w-full items-center justify-between border border-grey-300 p-sm"
        >
          <div className="typo-sm-medium">{label}</div>
          <div>
            <div className="typo-sm-medium flex items-center gap-xs font-monospace text-blue-600">
              {value}
              <CopyToClipboardButton
                color={ButtonColor.SECONDARY}
                iconSize={IconSize.MEDIUM}
                shape={ButtonShape.UNCONTAIN}
                valueToCopy={value}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SwitchConfiguredUrlList
